import * as React from 'react';
import styled from 'styled-components';
import { zPositions } from '@/constants';

import { theme } from 'components';
import { CALENDAR_OPTIONS } from 'utils';
import { AlmanacCalendarProviderType } from '@bb/domain/dist/types';
import Modal, { ModalBody } from '../react-common/Modal';

type CalendarSyncProviderModalProps = {
  showModal: boolean;
  redirectUser: (service: AlmanacCalendarProviderType) => void;
  closeModal: () => void;
};

type CalendarSyncProviderModalState = {
  isLoading: boolean;
};

class CalendarSyncProviderModal extends React.Component<
  CalendarSyncProviderModalProps,
  CalendarSyncProviderModalState
> {
  constructor(props: CalendarSyncProviderModalProps) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentDidUpdate(prevProps: CalendarSyncProviderModalProps) {
    if (prevProps.showModal !== this.props.showModal) {
      this.setState({ isLoading: false });
    }
  }

  redirectToOauth = (service: AlmanacCalendarProviderType) => {
    const { redirectUser } = this.props;

    this.setState({ isLoading: true });
    redirectUser(service);
  };

  render() {
    const { closeModal, showModal } = this.props;
    const { isLoading } = this.state;

    return (
      <Modal
        style={{ zIndex: zPositions.calendarSyncModal }}
        show={showModal}
        onHide={closeModal}
      >
        <ModalBody>
          <div className="row p-md">
            <h4 className="text-center">
              <strong>Which calendar do you use?</strong>
            </h4>
          </div>
          {isLoading ? (
            <div className="row p-md">
              <div className="col-sm-12 text-center">
                <i className="fa fa-spinner fa-spin fa-5x"></i>
              </div>
            </div>
          ) : (
            <>
              <div className="row p-xl">
                {CALENDAR_OPTIONS.map((calendarOption, index) => (
                  <StyledColumn
                    key={index}
                    className="col-sm-3 col-xs-6 text-center m-b"
                  >
                    <button
                      className="btn btn-default"
                      onClick={() =>
                        this.redirectToOauth(calendarOption.serviceName)
                      }
                    >
                      <div className="image-wrapper">
                        <img
                          src={calendarOption.image}
                          alt={calendarOption.altText}
                        />
                      </div>
                    </button>
                    <div className="icon-title">{calendarOption.title}</div>
                    {!!calendarOption.subtitle && (
                      <div className="icon-subtitle">
                        {calendarOption.subtitle}
                      </div>
                    )}
                  </StyledColumn>
                ))}
              </div>
              <div className="row text-center p-md">
                <button
                  className="btn btn-default"
                  onClick={() => closeModal()}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default CalendarSyncProviderModal;

const StyledColumn = styled.div`
  > button {
    width: 80%;
    max-width: 120px;
    &.btn {
      padding: 12px;
      border-radius: 8px;
    }
    > .image-wrapper {
      img {
        object-fit: contain;
        width: 100%;
      }
    }
  }
  .icon-title {
    margin-top: 16px;
    font-size: 16px;
  }
  .icon-subtitle {
    font-size: 14px;
    color: ${theme.textColorSecondary};
  }
`;
